import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 25,
        backgroundColor: '#54579C',
        height: '100%'
    },
    iconBackPage: {
        marginTop: 50
    },
    contentQrCode: {
        width: 250,
        height: 250,
        alignSelf: 'center',
        marginTop: '5%'
    },
    textInfoQrCode: {
        fontWeight: 'bold',
        fontSize: 14,
        textAlign: 'center',
        color: '#fff',
        marginTop: '40%'
    }
});

export default styles;
